"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import 'invariant';
import 'luxon';
import { GridList } from '../components/List/components/Items/views/GridList/GridList.mjs';
import 'react-aria-components';
import 'clsx';
import '@mittwald/react-tunnel';
import { viewComponentContext } from '../lib/viewComponentContext/viewComponentContext.mjs';
import '../lib/propsContext/propsContext.mjs';
import '../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import 'react-aria';
import '@tabler/icons-react';
import '../components/Icon/Icon.mjs';
import '../components/Button/Button.mjs';
import '../components/ContextMenu/ContextMenu.mjs';
import '../components/MenuItem/MenuItem.mjs';
import '../components/ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../components/ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../components/ColumnLayout/ColumnLayout.mjs';
import '../components/List/components/ListSummary/ListSummary.mjs';
import '../components/Heading/Heading.mjs';
import '../components/Text/Text.mjs';
import '../components/List/listContext.mjs';
import '../components/List/List.mjs';

const ItemsGridListView = (props) => {
  const View = useContext(viewComponentContext)["ItemsGridList"] ?? GridList;
  return /* @__PURE__ */ jsx(View, { ...props });
};

export { ItemsGridListView as default };
//# sourceMappingURL=ItemsGridListView.mjs.map
